jQuery(document).ready(function($) {
    let canBeLoaded = true;
    const bottomOffset = 200;
    let currentCategory = $('body').attr('class').match(/category-(\d+)/) ? $('body').attr('class').match(/category-(\d+)/)[1] : 'all';
    let currentPage = 1;
    let currentSearchTerm = '';
    let noMorePosts = false;

    $(`.category-filter[data-filter="${currentCategory}"]`).addClass('active');
    
    // Función AJAX para cargar los posts (búsqueda o filtrado)
    function loadPosts(page, category, search) {
        console.log("Cargando posts:", { page, category, search });
        $.ajax({
            url: wp_loadmore_params.ajaxurl,
            type: 'POST',
            data: {
                action: 'load_posts_by_filter',
                page: page,
                category: category,
                search: search,
                security: wp_loadmore_params.nonce
            },
            beforeSend: function() {
                canBeLoaded = false;
            },
            success: function(response) {
                if (response.success) {
                    if (page === 1) {
                        $('#posts-container').html(response.data.html);
                    } else {
                        $('#posts-container').append(response.data.html);  // Agregar más posts
                    }

                    currentPage = page;
                    canBeLoaded = true;

                    if (response.data.no_more_posts) {
                        noMorePosts = true;
                    }
                }
            },
            error: function() {
                canBeLoaded = true;
                console.log("Error al cargar los posts.");
            }
        });
    }

    // Manejar clic en los botones de categoría
    $('.category-filter').on('click', function() {
        currentCategory = $(this).data('filter');
        currentSearchTerm = '';  // Limpiar término de búsqueda
        currentPage = 1;
        noMorePosts = false;

        // Cargar posts filtrados por la categoría seleccionada
        loadPosts(currentPage, currentCategory, currentSearchTerm);
    });

    // Manejar clic en el botón de búsqueda
    $('#search-btn').on('click', function() {
        currentSearchTerm = $('#searching').val();
        currentCategory = 'all';  // Reiniciar la categoría a "ver todo" al buscar
        currentPage = 1;
        noMorePosts = false;

        loadPosts(currentPage, currentCategory, currentSearchTerm);
    });

    // Manejar búsqueda al presionar Enter en el campo de búsqueda
    $('#searching').on('keypress', function(e) {
        if (e.which === 13) {  // Código de tecla para Enter es 13
            $('#search-btn').click();  // Simular un clic en el botón de búsqueda
            e.preventDefault();  // Prevenir el comportamiento por defecto
        }
    });

    // Carga infinita al hacer scroll
    $(window).scroll(function() {
        const lastPostOffset = $('#posts-container .post__card:last').offset().top + $('#posts-container .post__card:last').height();
        const scrollPosition = $(window).scrollTop() + $(window).height();

        if (scrollPosition > lastPostOffset - bottomOffset && canBeLoaded && !noMorePosts) {
            currentPage++;
            loadPosts(currentPage, currentCategory, currentSearchTerm);
        }
    });
});